
import { UserIcon, ChevronLeftIcon } from "vue-feather-icons";
import AccountBody from "@/pages/account/components/AccountBody.vue";
import AddressEdit from "@/pages/account/components/AddressEdit.vue";
import TopMobileBack from "../components/TopMobileBack.vue";
import addressMixin from '@/mixins/addressMixin.js';
export default {
  layout: "account",
  name: "accountPage",
  middleware: "auth",
  mixins: [addressMixin],
  data() {
    return {
      tab2: "",
      TopMobileBackInfo: {
        title: this.$t("My addresses"),
        icon: "shopping-bag",
      },
    };
  },

  async created() {
    try {
      await this.addressService.fetchAddresses();
    } catch (error) {
    }
  },
  methods: {},
  components: {
    UserIcon,
    ChevronLeftIcon,
    AccountBody,
    AddressEdit,
    TopMobileBack,
  },
};
